import * as angular from 'angular';

angular.module('app').constant('keyCodes', {
	leftArrow: 37,
	rightArrow: 39,
	escape: 27,
	a: 65,
});
